/* eslint-disable consistent-return */
import { toast } from 'react-toastify';
import { popBusy, pushBusy } from './busyStore';
import { baseUrl } from './urls';

/**
 * Runs `request`, and while it is in flight keeps a global busy entry so the
 * app-wide overlay is shown. Pass `options.busy` (a message) only for calls a
 * user explicitly triggered — background loads should stay silent and rely on
 * their own inline placeholders.
 */
const withBusy = (options, callback, errorcallback, request) => {
  const message = options != null ? options.busy : null;
  const token = message ? pushBusy(message, options.busyNote) : null;
  const done = (handler, payload, fallback) => {
    popBusy(token);
    if (handler != null) {
      handler(payload);
    } else if (fallback != null) {
      fallback(payload);
    }
  };
  request(
    (retData) => done(callback, retData),
    (err) => done(errorcallback, err, errorHandlerNew)
  );
};

const runFetch = (url, requestOptions, callback, errorcallback) => {
  fetch(url, requestOptions)
    .then(async (resp) => {
      const respData = await resp.json();
      const retData = { status: resp.status, data: respData };
      if (!resp.ok) {
        return Promise.reject(retData);
      }
      callback(retData);
    })
    .catch((err) => {
      console.log(err);
      errorcallback(err);
    });
};

export const APIRequest = (
  token,
  endpoint,
  data,
  callback,
  errorcallback,
  options
) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Token': `${token}`,
    },
    body: JSON.stringify(data),
  };
  const url = `${baseUrl}${endpoint}`;
  console.log(url, data);
  withBusy(options, callback, errorcallback, (onDone, onError) =>
    runFetch(url, requestOptions, onDone, onError)
  );
};

/**
 * Unauthenticated POST, for the handful of endpoints routed outside the session resolver.
 * Same contract as PublicGetRequest.
 */
export const PublicPostRequest = (endpoint, data, callback, errorcallback, options) => {
  const url = `${baseUrl}${endpoint}`;
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data == null ? {} : data),
  };
  withBusy(options, callback, errorcallback, (onDone, onError) =>
    runFetch(url, requestOptions, onDone, onError)
  );
};

export const PublicGetRequest = (endpoint, callback, errorcallback, options) => {
  const url = `${baseUrl}${endpoint}`;
  withBusy(options, callback, errorcallback, (onDone, onError) =>
    runFetch(url, undefined, onDone, onError)
  );
};

/**
 * The sponsorship items a cart was rejected over, flattened into one list. The server reports on the
 * whole cart in one go — `unavailableProducts` for items that are gone for good, `lockedProducts`
 * for ones somebody else is mid-payment on — because naming only the first offender made a
 * contributor holding several of them clear them one failed payment attempt at a time.
 */
export const contendedProducts = (err) => {
  const payload = err != null && err.data != null ? err.data : {};
  return [
    ...(payload.unavailableProducts || []).map((p) => ({ ...p, retriable: false })),
    ...(payload.lockedProducts || []).map((p) => ({ ...p, retriable: true })),
  ];
};

const CONTENDED_KEY = 'contendedPrds';

/**
 * A cart the server will not take cannot be fixed from the summary page — the items can only be
 * changed back on the sponsorship page. These two hand the verdict across that navigation so the
 * offending tiles are already marked when the contributor lands there.
 */
export const handOverContended = (items) => {
  localStorage.setItem(CONTENDED_KEY, JSON.stringify(items));
};

export const takeContendedHandover = () => {
  const stashed = localStorage.getItem(CONTENDED_KEY);
  localStorage.removeItem(CONTENDED_KEY);
  if (stashed == null) return [];
  try {
    return JSON.parse(stashed);
  } catch (error) {
    return [];
  }
};

// Error handler

export const errorHandlerNew = (err) => {
  try {
    if (err.status) {
      console.log(err.status);
    }
    if (err.data.error === 'InsufficientAccess') {
      localStorage.removeItem('selectedPrds');
      localStorage.removeItem('totalCartPrice');
      localStorage.removeItem('user-info');
      localStorage.clear();
    }
    const contended = contendedProducts(err);
    if (contended.length > 0) {
      // Name them. `desc` is one sentence about "the selected sponsorship item", which is no use
      // at all to somebody who selected four of them.
      toast.error(`${err.data.desc} — ${contended.map((p) => p.name).join(', ')}`);
      return;
    }
    toast.error(err.data.desc);
  } catch (error) {
    console.log(error);
    toast.error('Seems some internal issue with your network, please check your network!');
  }
};
